import { render } from "./TextLink.vue?vue&type=template&id=2eb0442b&scoped=true"
import script from "./TextLink.vue?vue&type=script&lang=js"
export * from "./TextLink.vue?vue&type=script&lang=js"

import "./TextLink.vue?vue&type=style&index=0&id=2eb0442b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb0442b"]])

export default __exports__